export class Role {
    public id: string;
    public roleName: string;
    public description: string;
    public numberOfUsers: string;
    public claims: Array<any>;
}
